import { z } from "zod";
import {
	EVENT_BOOKING_SCOPE,
	EVENT_CURRENCY_DEFAULT,
	EVENT_GROUP_BOOKING_MODE,
} from "../constants/event.constants";

export const eventCategoryIdSchema = z.coerce
	.number()
	.int()
	.positive()
	.describe("Event category identifier");

export const eventCategorySchema = z
	.object({
		eventCategoryId: eventCategoryIdSchema.optional(),
		tenantId: z.coerce.number().int().positive(),
		name: z.string().min(1).max(200),
		slug: z
			.string()
			.min(1)
			.max(200)
			.regex(/^[a-z0-9-]+$/),
		description: z.string().max(2000).nullable(),
		membershipScope: z.enum(EVENT_BOOKING_SCOPE).default("member_only"),
		allowNonMember: z.boolean().default(false),
		isPaidEvent: z.boolean().default(false),
		defaultPrice: z
			.union([z.coerce.number().nonnegative(), z.null()])
			.optional(),
		currency: z.string().length(3).default(EVENT_CURRENCY_DEFAULT),
		groupBookingMode: z.enum(EVENT_GROUP_BOOKING_MODE).default("single"),
		allowMultipleBookings: z.boolean().default(false),
		defaultReminderTemplateId: z.coerce.number().int().positive().nullable(),
		defaultCancellationPolicyId: z.coerce.number().int().positive().nullable(),
		reservationStartAt: z.coerce.date().nullable(),
		reservationEndAt: z.coerce.date().nullable(),
		isPublished: z.boolean().default(false),
		publishedAt: z.coerce.date().nullable(),
		createdBy: z.coerce.number().int().positive().nullable(),
		updatedBy: z.coerce.number().int().positive().nullable(),
		createdAt: z.coerce.date().optional(),
		updatedAt: z.coerce.date().optional(),
		deletedAt: z.coerce.date().nullable().optional(),
	})
	.strict();

export const createEventCategorySchema = eventCategorySchema
	.omit({
		eventCategoryId: true,
		createdAt: true,
		updatedAt: true,
		deletedAt: true,
		publishedAt: true,
	})
	.extend({
		tenantId: z.coerce.number().int().positive().optional(),
		description: z.string().max(2000).optional().nullable(),
		membershipScope: z.enum(EVENT_BOOKING_SCOPE).optional(),
		allowNonMember: z.boolean().optional(),
		isPaidEvent: z.boolean().optional(),
		defaultPrice: z
			.union([z.coerce.number().nonnegative(), z.null()])
			.optional(),
		currency: z.string().length(3).optional(),
		groupBookingMode: z.enum(EVENT_GROUP_BOOKING_MODE).optional(),
		allowMultipleBookings: z.boolean().optional(),
		defaultReminderTemplateId: z.coerce
			.number()
			.int()
			.positive()
			.optional()
			.nullable(),
		defaultCancellationPolicyId: z.coerce
			.number()
			.int()
			.positive()
			.optional()
			.nullable(),
		reservationStartAt: z.coerce.date().optional().nullable(),
		reservationEndAt: z.coerce.date().optional().nullable(),
		isPublished: z.boolean().optional(),
		createdBy: z.coerce.number().int().positive().optional().nullable(),
		updatedBy: z.coerce.number().int().positive().optional().nullable(),
		// Accept publishedAt on create but do not require it; service ignores this field on insert
		publishedAt: z.coerce.date().optional().nullable(),
	});

export const updateEventCategorySchema = createEventCategorySchema.partial({
	name: true,
	slug: true,
	description: true,
	membershipScope: true,
	allowNonMember: true,
	isPaidEvent: true,
	defaultPrice: true,
	currency: true,
	groupBookingMode: true,
	allowMultipleBookings: true,
	defaultReminderTemplateId: true,
	defaultCancellationPolicyId: true,
	reservationStartAt: true,
	reservationEndAt: true,
	isPublished: true,
	publishedAt: true,
	createdBy: true,
	updatedBy: true,
});
